<template>
  <div class="nowrap">
    <a class="data-table-action"
       :title="$t('delete')"
       v-b-tooltip.hover
       @click="deleteObject">
      <DeleteSvg class="svg-stroke-light"/>
    </a>
  </div>
</template>

<script setup>
import DeleteSvg from '@/assets/svg-vue/general/delete2.svg'
import {computed, getCurrentInstance, onBeforeMount} from "vue"
import {useStore} from "vuex"

const props = defineProps({
  object: {
    type: Object
  }
})

let i18n = null
let noty = null
const store = useStore()

const superadmin = computed(() => store.state.auth.superadmin)

onBeforeMount(() => {
  const instance = getCurrentInstance()
  i18n = instance?.ctx?.$i18n
  noty = instance?.appContext?.app?.noty
})

const deleteObject = async () => {
  let mes = 'are_you_sure_you_want_to_delete_template'
  if (!confirm(i18n.t(mes))) return
  try {
    await store.dispatch('deleteModel', {
      id: props.object.id,
      model: props.object.template_type.replaceAll('_templates', '_template'),
      superadmin: superadmin.value,
    })
    noty.info(i18n.t('success_message'))
  } catch (e) {
    console.log(e)
  }
}
</script>

<style scoped>

</style>
